import React from "react";
import Email from "../images/Email.svg";
import Password from "../images/Password.svg";

export default function SecondaryInput({
  type = "text",
  placeholder,
  required = false,
  value,
  setValue,
  error = null,
  viewMode,
  pattern,
  number = false,
  disabled = false,
  ref = null,
  maxLength = 30,
}) {
  const onPress = (e) => {
    const re = /^[0-9\b]+$/;

    if (number === true) {
      if (e.target.value === "" || re.test(e.target.value)) {
        return true;
      } else return false;
    }
  };
  const onChange = (e) => {
    const re = /^[0-9\b]+$/;

    if (number === true) {
      if (e.target.value === "" || re.test(e.target.value)) {
        //console.log("number input");
        setValue(e.target.value);
      }
    } else setValue(e.target.value);
  };

  return (
    <div className="relative pb-5">
      <input
        disabled={disabled || viewMode}
        ref={ref}
        type={type}
        pattern={pattern}
        value={value}
        className={`${error ? "error-input" : "text-input"}`}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        onKeyDown={onPress}
        maxLength={maxLength}
      />
      {error ? (
        <div className="w-full absolute left-0 bottom-0 flex items-center pointer-events-none overflow-hidden h-4">
          <div className="text-center">
            <p className="text-red-600 h-[20px] text-[12px] tracking-tight font-medium">
              {error}
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
